import Lang from '@/modules/core/app/services/Lang';
import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { PlatformProduct } from '@/modules/platformproduct/models/PlatformProduct';

export class BillingAdvisorProPlanUsageObject extends BaseModel {
  platformProduct?: PlatformProduct | null;
  remainingFreeWills: number;
  totalFreeWills: number;

  constructor(model: Partial<BillingAdvisorProPlanUsageObject> = {}) {
    super();

    this.platformProduct = PlatformProduct.mapModelOrNull(model.platformProduct);
    this.remainingFreeWills = model.remainingFreeWills ?? 0;
    this.totalFreeWills = model.totalFreeWills ?? 0;
  }

  get usedFreeWills(): number {
    return this.totalFreeWills - this.remainingFreeWills;
  }

  get nextPaymentDate(): string {
    if (!this.platformProduct) {
      return '';
    }

    const date: string = this.platformProduct?.nextBillingAt
      ? this.platformProduct.isoFormattedNextBillingAt
      : Lang.t('financialadvisor.none-scheduled');

    return Lang.t('financialadvisor.next-payment-date', { date });
  }

  get activeUntil(): string {
    if (!this.platformProduct) {
      return '';
    }

    return Lang.t('financialadvisor.active-until', {
      date: this.platformProduct.isoFormattedCancelAt
    });
  }

  get hasUsedFreeWills(): boolean {
    return this.usedFreeWills > 0;
  }
}
